import React, { Fragment, useEffect, useRef } from "react";
import { Typography } from "@mui/material";
import { Field, Form, FormikProvider, useFormik } from "formik";
import * as Yup from "yup";
import { makeStyles } from "@mui/styles";
import moment from "moment";
import DownloadIcon from "@mui/icons-material/Download";
// import HtmlToPdf from "../../common/HtmlToPdf";
import { processHtmlToPdf } from "../../common/HtmlToPdf";

const useStyles = makeStyles((theme) => ({
  label: {
    width: "25%",
    cursor: "pointer",
  },
  inputBox: {
    width: "50%",
  },
  subHeading: {
    paddingBottom: 20,
    color: "blue",
  },
}));

function addScript(url) {
  const script = document.createElement("script");
  script.type = "application/javascript";
  script.src = url;
  document.head.appendChild(script);
}
addScript(
  "https://raw.githack.com/eKoopmans/html2pdf/master/dist/html2pdf.bundle.js"
);

const StaticSalaryForm = ({
  salarySlipData: values,
  selectedMonth,
  selectedYear,
  profileData,
}) => {
  const classes = useStyles();
  const testingPdfPrint = useRef(null);
  const htmlToPdfRef = useRef(null);
  const onButtonClick = () => {
    // verifyAndSearchUser(values.faculty_id);
    alert("on button click handler");
  };

  const renderAbbr = () => {
    return (
      <Fragment>
        <div className="d-flex bd-highlight">
          <div className="w-10 bd-highlight">PF:</div>
          <div className="bd-highlight">Providient Fund</div>
        </div>
        <div className="d-flex bd-highlight">
          <div className="w-10 bd-highlight">HRA:</div>
          <div className="bd-highlight">House Rent Allowance</div>
        </div>
        <div className="d-flex bd-highlight">
          <div className="w-10 bd-highlight">DA:</div>
          <div className="bd-highlight">Dearness allowance</div>
        </div>
        <div className="d-flex bd-highlight">
          <div className="w-10 bd-highlight">CA:</div>
          <div className="bd-highlight">City Allowance</div>
        </div>

        <div className="d-flex bd-highlight">
          <div className="w-10 bd-highlight">GPF:</div>
          <div className="bd-highlight">General Provident Fund</div>
        </div>
        <div className="d-flex bd-highlight">
          <div className="w-10 bd-highlight">LIC:</div>
          <div className="bd-highlight">Life Insurance</div>
        </div>
        <div className="d-flex bd-highlight">
          <div className="w-10 bd-highlight">GPFL:</div>
          <div className="bd-highlight">General Provident Fund Loan</div>
        </div>
        <div className="d-flex bd-highlight">
          <div className="w-10 bd-highlight">GLIC:</div>
          <div className="bd-highlight">Group Life Insurance</div>
        </div>
        <div className="d-flex bd-highlight">
          <div className="w-10 bd-highlight">GSLI:</div>
          <div className="bd-highlight">Group Scheme Life Insurance</div>
        </div>
        <div className="d-flex bd-highlight">
          <div className="w-10 bd-highlight">ITax:</div>
          <div className="bd-highlight">Income Tax</div>
        </div>
      </Fragment>
    );
  };

  const renderContent = () => {
    return (
      <div className="card">
        <div
          className="card-header"
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <div>
            <h3 className="card-title">
              Below is the salary slip for:&nbsp;
              <span
                className="font-weight-bold"
                style={{ textDecoration: "underline" }}
              >
                {selectedMonth}'{selectedYear}
              </span>
            </h3>
          </div>
          <div
            onClick={() =>
              processHtmlToPdf({
                nodeId: "salary-form-container",
                header: "St. Andrews College",
                title: `Salary slip for: ${selectedMonth}'${selectedYear}`,
                footer: `*Salary slip generated on : ${moment(
                  new Date()
                ).format(
                  "DD-MMM-YYYY: hh:mm A"
                )} \n*This is a computer generated salary slip. No signature is required.`,
                filename: `${profileData.full_name.first_name} (${values.faculty_id}) - ${selectedMonth} ${selectedYear}`,
                orientation: "p",
                pageType: 'canvas'
              })
            }
          >
            <h6 style={{ float: "right", cursor: "pointer" }}>
              Download pdf
              <DownloadIcon />
            </h6>
          </div>
          {/* <HtmlToPdf
            htmlToPdfRef={htmlToPdfRef} 
            nodeId ="salary-form-container"
            header = "St. Andrews College"
            title = {`Salary slip for: ${selectedMonth}'${selectedYear}`}
            footer = {`*Salary slip generated on : ${moment(new Date()).format("DD-MMM-YYYY: hh:mm A")} \n*This is a computer generated salary slip. No signature is required.`}
            filename ={`${profileData.full_name.first_name} (${values.faculty_id}) - ${selectedMonth} ${selectedYear}`}
          /> */}
        </div>
        <div className="card-body">
          {renderSalaryForm2()}
          <hr className="section-hr" />
          <div className="mt-4">
            {renderAbbr()}
            <div
              onClick={() =>
                processHtmlToPdf({
                  nodeId: "salary-form-container",
                  header: "St. Andrews College",
                  title: `Salary slip for: ${selectedMonth}'${selectedYear}`,
                  footer: `*Salary slip generated on : ${moment(
                    new Date()
                  ).format(
                    "DD-MMM-YYYY: hh:mm A"
                  )} \n*This is a computer generated salary slip. No signature is required.`,
                  filename: `${profileData.full_name.first_name} (${values.faculty_id}) - ${selectedMonth} ${selectedYear}`,
                  orientation: "p",
                  pageType: 'canvas'
                })
              }
            >
              <h6
                style={{ float: "left", paddingTop: "2rem", cursor: "pointer" }}
              >
                Download pdf
                <DownloadIcon />
              </h6>
            </div>
            {/* <div className="pt-4" style={{float:"left"}}>
            <HtmlToPdf 
            htmlToPdfRef={htmlToPdfRef}
            nodeId ="salary-form-container"
            header = "St. Andrews College"
            title = {`Salary slip for: ${selectedMonth}'${selectedYear}`}
            footer = {`*Salary slip generated on : ${moment(new Date()).format("DD-MMM-YYYY: hh:mm A")}`}
            filename ={`${profileData.full_name.first_name} (${values.faculty_id}) - ${selectedMonth} ${selectedYear}`}
          />
            </div> */}
          </div>
        </div>
      </div>
    );
  };
  const renderSalaryForm2 = () => {
    return (
      <div
        ref={testingPdfPrint}
        style={{ display: "contents", fontSize: "12pt" }}
        id="salary-static-form"
      >
        <div id="salary-form-container">
          <div id="top" style={{ display: "flex", flexDirection: "row" }}>
            <div
              id="left"
              className="col-md-6"
              style={{ display: "flex", flexDirection: "column" }}
            >
              <div className="form-group">
                <label className={classes.label}>College ID:</label>
                {values.faculty_id}
              </div>
              <div className="form-group">
                <label className={classes.label}>First Name:</label>
                {profileData.full_name.first_name}
              </div>
              <div className="form-group">
                <label className={classes.label}>Middle Name:</label>
                {profileData.full_name.middle_name}
              </div>
              <div className="form-group">
                <label className={classes.label}>Last Name:</label>
                {profileData.full_name.last_name}
              </div>
              <div className="form-group">
                <label className={classes.label}>Department:</label>
                {profileData.department}
              </div>
              <div className="form-group">
                <label className={classes.label}>Joining Date:</label>
                {profileData.date_of_joining &&
                  new Date(profileData.date_of_joining)
                    ?.toISOString()
                    .substring(0, 10)}
              </div>
            </div>
            <div
              id="right"
              className="col-md-6"
              style={{ display: "flex", flexDirection: "column" }}
            >
              <div className="form-group">
                <label className={classes.label}>Email:</label>
                {profileData.email_id}
              </div>
              <div className="form-group">
                <label className={classes.label}>Gender:</label>
                {profileData.gender}
              </div>
              {/* <div className="form-group">
              <label className={classes.label}>Super Admin:</label>
              {profileData.isSuperAdmin ? "Yes" : "No"}
            </div> */}
              <div className="form-group">
                <label className={classes.label}>Teaching/Non-teaching:</label>
                {profileData.is_technical ? "Teaching" : "Non-Teaching" || "-"}
              </div>
              <div className="form-group">
                <label className={classes.label}>Date of birth:</label>
                {profileData.date_of_birth &&
                  new Date(profileData.date_of_birth)
                    ?.toISOString()
                    .substring(0, 10)}
              </div>
              <div className="form-group">
                <label className={classes.label}>Phone:</label>
                {profileData.mobile_number}
              </div>
            </div>
          </div>
          <hr className="section-hr" />
          <Typography variant="subtitle1">Earnings:</Typography>
          <br />
          {values.earnings?.length > 0 && (
            <div id="middle" style={{ display: "flex", flexDirection: "row" }}>
              <div
                id="left"
                className="col-md-6"
                style={{ display: "flex", flexDirection: "column" }}
              >
                <div className="form-group">
                  <label title="Basic salary" className={classes.label}>
                    Basic pay:&nbsp;&#8377;
                  </label>
                  {
                    values.earnings.filter((val) => val.category === "basic")[0]
                      .calculated_amount
                  }
                </div>
                <div className="form-group">
                  <label title="Dearness allowance" className={classes.label}>
                    DA:&nbsp;(
                    {
                      values.earnings.filter((val) => val.category === "DA")[0]
                        .percentage
                    }
                    %)
                  </label>
                  {
                    values.earnings.filter((val) => val.category === "DA")[0]
                      .calculated_amount
                  }
                </div>
              </div>
              <div
                id="right"
                className="col-md-6"
                style={{ display: "flex", flexDirection: "column" }}
              >
                <div className="form-group">
                  <label title="House Rent Allowance" className={classes.label}>
                    HRA:&nbsp;(
                    {
                      values.earnings.filter((val) => val.category === "HRA")[0]
                        .percentage
                    }
                    %)
                  </label>
                  {
                    values.earnings.filter((val) => val.category === "HRA")[0]
                      .calculated_amount
                  }
                </div>
                <div className="form-group">
                  <label title="City Allowance" className={classes.label}>
                    CA:&nbsp;(
                    {
                      values.earnings.filter((val) => val.category === "CA")[0]
                        .percentage
                    }
                    %)
                  </label>
                  {
                    values.earnings.filter((val) => val.category === "CA")[0]
                      .calculated_amount
                  }
                </div>
              </div>
            </div>
          )}
          <hr className="section-hr" />
          <Typography variant="subtitle1">Deductions:</Typography>
          <br />
          {values.deductions?.length > 0 && (
            <div id="bottom" style={{ display: "flex", flexDirection: "row" }}>
              <div
                id="left"
                className="col-md-6"
                style={{ display: "flex", flexDirection: "column" }}
              >
                <div className="form-group">
                  <label title="Provident Fund" className={classes.label}>
                    PF:&nbsp;(
                    {
                      values.deductions.filter(
                        (val) => val.category === "PF"
                      )[0].percentage
                    }
                    %)
                  </label>
                  {
                    values.deductions.filter((val) => val.category === "PF")[0]
                      .calculated_amount
                  }
                </div>
                <div className="form-group">
                  <label title="Life Insurance" className={classes.label}>
                    LIC:&nbsp;(
                    {
                      values.deductions.filter(
                        (val) => val.category === "LIC"
                      )[0].percentage
                    }
                    %)
                  </label>
                  {
                    values.deductions.filter((val) => val.category === "LIC")[0]
                      .calculated_amount
                  }
                </div>
                <div className="form-group">
                  <label title="Group Life Insurance" className={classes.label}>
                    GLIC:&nbsp;(
                    {
                      values.deductions.filter(
                        (val) => val.category === "GLIC"
                      )[0].percentage
                    }
                    %)
                  </label>
                  {
                    values.deductions.filter(
                      (val) => val.category === "GLIC"
                    )[0].calculated_amount
                  }
                </div>
                <div className="form-group">
                  <label title="Income Tax" className={classes.label}>
                    ITax:&nbsp;(
                    {
                      values.deductions.filter(
                        (val) => val.category === "ITax"
                      )[0].percentage
                    }
                    %)
                  </label>
                  {
                    values.deductions.filter(
                      (val) => val.category === "ITax"
                    )[0].calculated_amount
                  }
                </div>
              </div>
              <div
                id="right"
                className="col-md-6"
                style={{ display: "flex", flexDirection: "column" }}
              >
                <div className="form-group">
                  <label
                    title="General Provident Fund"
                    className={classes.label}
                  >
                    GPF:&nbsp;(
                    {
                      values.deductions.filter(
                        (val) => val.category === "GPF"
                      )[0].percentage
                    }
                    %)
                  </label>
                  {
                    values.deductions.filter((val) => val.category === "GPF")[0]
                      .calculated_amount
                  }
                </div>
                <div className="form-group">
                  <label
                    title="General Provident Fund Loan"
                    className={classes.label}
                  >
                    GPFL:&nbsp;(
                    {
                      values.deductions.filter(
                        (val) => val.category === "GPFL"
                      )[0].percentage
                    }
                    %)
                  </label>
                  {
                    values.deductions.filter(
                      (val) => val.category === "GPFL"
                    )[0].calculated_amount
                  }
                </div>
                <div className="form-group">
                  <label
                    title="Group Scheme Life Insurance"
                    className={classes.label}
                  >
                    GSLI:&nbsp;(
                    {
                      values.deductions.filter(
                        (val) => val.category === "GSLI"
                      )[0].percentage
                    }
                    %)
                  </label>
                  {
                    values.deductions.filter(
                      (val) => val.category === "GSLI"
                    )[0].calculated_amount
                  }
                </div>
              </div>
            </div>
          )}
          <hr className="section-hr" />
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
            }}
          >
            <Typography variant="subtitle1">
              Total Earnings: &#8377;
              {values.total_earnings}
            </Typography>
            <br />
            <Typography variant="subtitle1">
              Total Deductions: &#8377;
              {values.total_deductions}
            </Typography>
            <br />
            <Typography variant="subtitle1">
              Total net: &#8377;
              {values.total_net}
            </Typography>
            <br />
          </div>
        </div>
      </div>
    );
  };

  return <Fragment>{renderContent()}</Fragment>;
};

export default StaticSalaryForm;
